<template>

    <!-- FLASH MESSAGES -->
    <v-snackbar
            v-model="showFlashMessage"
            :timeout="messageDuration"
            :top="top"
            :bottom="bottom"
            :multi-line="messageMultiLine"
            :color="messageColor"
    >
        <div class="d-flex no-wrap">

            <v-icon class="align-self-center mr-3" color="white">
                {{messageIcon}}
            </v-icon>
            <div class="align-self-center">
                {{ message }}
            </div>
        </div>
    </v-snackbar>

</template>

<script>

import {timeDisplay} from "@/components/mixins/timeDisplayMixin.js";

export default {

    mixins: [timeDisplay],

    data() {
        return {
            showFlashMessage: false,
            message: null,
            messageColor: 'blue',
            messageIcon: null,
            messageDuration: 5000,
                messageMultiLine: true,
                messageLocation: 'top'
            }
        },

        computed: {
            bottom() {
                return this.messageLocation === 'bottom';
            },
            top() {
                return this.messageLocation === 'top';
            }
        },

        created() {
            Bus.$on('flash-message', (data) => {

                this.message = data.message;

                this.messageDuration = data.duration ? data.duration : 5000;
                this.messageMultiLine = data.multiline ? data.multiline : false;
                this.messageLocation = data.location ? data.location : 'top';

                if (data.type) {
                    if (data.type === "info") {
                        this.messageColor = "blue";
                        this.messageIcon = 'mdi-alert-circle-outline';
                    } else if (data.type === "warning") {
                        this.messageColor = "amber darken-4";
                        this.messageIcon = 'mdi-alert-outline';
                    } else if (data.type === "error") {
                        this.messageColor = "error";
                        this.messageIcon = 'mdi-alert';
                    } else if (data.type === "success") {
                        this.messageColor = "success";
                        this.messageIcon = 'mdi-check';
                    } else if (data.type === "debug") {
                        this.messageColor = "grey darken-2";
                        this.messageIcon = 'mdi-bug';
                    } else {
                        this.messageColor = "red";
                        this.messageIcon = 'mdi-error';
                        this.message = "FLASH MESSAGE: Valid types are info, success, warning, error and debug";
                    }
                } else {
                    this.messageColor = "blue";
                    this.messageIcon = 'mdi-alert-circle-outline';
                }

                this.showFlashMessage = true;
            });

            Bus.$on('server-error', () => {
                this.messageColor = "red";
                this.message = "OOPS! Server error has happened.";
                this.showFlashMessage = true;
            });
        },

        methods: {}
    }
</script>
